export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14281.49f8cfb0.jpg";